// Basic
import PropTypes from 'prop-types';
import { useState } from 'react';
// Libs
import { cn } from '@/common-utils/libraries/tailwind/utils';
// Store & actions
import useRootOrganizationStore from '@/app/store/rootOrganization';
import actionsSims from '../../../api/actionsSims';
// Components
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import AddSimCardsByProvider from './components/AddSimCardsByProvider';
import Entity from '@/common-utils/components/renders/entity/Entity';
import FooterForm from '@/common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import { Modal, ModalBody, ModalContent } from '@/common-utils/components/ui/modal';
// Common
import splitLines from '../../../funcs/splitLines';
import SIM_OFFERS_PROVIDERS from '../../../enums/SimOffersProviders';
import { useToast } from '@/common-utils/hooks/use-toast';
// Lang
import { nsOrganization, nsSimCard } from '@/app/i18n/namespaces';

/**
 * @param {JSX.Element} trigger element that triggers modal opening
 * @returns {JSX.Element} ModalResetPassword Component
 */
function ModalAddSimCardToOrganization({ isOpen, setIsOpen, setLaunchRefetch }) {

    // Constants
    const PROVIDERS_OPTIONS = Object.values(SIM_OFFERS_PROVIDERS).map((item) => ({ value: item.key, name: item.entities.name, namespace: nsOrganization }));

    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);

    // Toast
    const { toast } = useToast();

    // State
    const [disableSubmit, setDisableSubmit] = useState(true);
    const [simProvider, setSimProvider] = useState('');
    const [simNumberList, setSimNumberList] = useState('');

    // API Calls add SimCard
    const onSuccess = () => {
        setIsOpen(false);
        setLaunchRefetch(true);
        toast({
            description: <Entity entity={'modal.add.success'} namespace={nsSimCard} />,
            variant: 'success'
        });
    };
    const onError = () => {
        setIsOpen(false);
        toast({
            description: <Entity entity={'modal.add.error'} namespace={nsSimCard} />,
            variant: 'danger'
        });
    };
    const submitAddSimCards = actionsSims.addSimCards(onSuccess, onError);

    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            <ModalContent className={cn('max-w-lg')}>
                <HeaderTitle title={'modal.add.title'} namespace={nsSimCard} />
                <ModalBody>

                    <AddSimCardsByProvider
                        simProvider={simProvider}
                        setSimProvider={setSimProvider}
                        simNumberList={simNumberList}
                        setSimNumberList={setSimNumberList}
                        setDisableSubmit={setDisableSubmit}
                        providersOptions={PROVIDERS_OPTIONS}
                    />
                </ModalBody>
                <FooterForm
                    onSubmit={() => {
                        submitAddSimCards.mutate({
                            simProvider: simProvider,
                            iccids: splitLines(simNumberList).filter((simNumber, index) => index <= 249).join('\n'),
                            organizationId: rootOrganization.uuid
                        });
                        if (splitLines(simNumberList).length > 249) {
                            submitAddSimCards.mutate({
                                simProvider: simProvider,
                                iccids: splitLines(simNumberList).filter((simNumber, index) => index > 249).join('\n'),
                                organizationId: rootOrganization.uuid
                            });
                        }
                    }}
                    isSubmitDisabled={!simProvider || !simNumberList || disableSubmit}
                    isSubmitting={submitAddSimCards.isLoading}
                />
            </ModalContent>
        </Modal>
    );
}

ModalAddSimCardToOrganization.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    setLaunchRefetch: PropTypes.func.isRequired
};

export default ModalAddSimCardToOrganization;